import { UPDATE_USER_INFO_JSON, RESET_USER_INFO_JSON } from "./userInfoJsonReducer"

export const updateUserInfoJson = (obj) => ({
    type: UPDATE_USER_INFO_JSON,
    payload: obj
})

export const resetUserInfoJson = () => ({
    type: RESET_USER_INFO_JSON,
})